export default __webpack_public_path__ + "static/media/puppyFemaleLightGreen.220a74da.jpg";